import { render, staticRenderFns } from "./FileItem.vue?vue&type=template&id=618a981b&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=js"
export * from "./FileItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a981b",
  null
  
)

export default component.exports